import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { IAnnotation } from './PdfPage';

const useStyles = makeStyles((theme: Theme) => ({
  annotationLink: {
    position: 'absolute',
    fontSize: '1em',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    '&:hover': {
      opacity: 0.2,
      background: '#ff0',
      boxShadow: '0px 2px 10px #ff0',
    },
  },
}));

interface IProps {
  pageAnnotations?: IAnnotation[];
}

const PageAnnotations = (props: IProps) => {
  const classes = useStyles(props);
  const { pageAnnotations } = props;

  return (
    <>
      {pageAnnotations?.map(annotation => (
        <div
          key={annotation.id}
          style={{
            position: 'absolute',
            width: `${annotation.width}%`,
            height: `${annotation.height}%`,
            left: `${annotation.x}%`,
            top: `${annotation.y}%`,
          }}
        >
          <a
            className={classes.annotationLink}
            title={annotation.url}
            href={annotation.url}
            target="_blank"
            rel="noopener noreferrer nofollow"
          />
        </div>
      ))}
    </>
  );
};

export default React.memo(PageAnnotations);
